import React, { useState, createContext } from "react"

export const VideoContext = createContext()

export const VideoProvider = (props) => {
  const [video, setVideo] = useState({
    id: "",
    title: "",
    descr: "",
    src: "",
    type: "",
    artist: "",
    singThursday: false,
    coverImg: "",
    currentPlaying: {
      videoId: "",
      isPlaying: false,
    },
  })
  return (
    <VideoContext.Provider value={[video, setVideo]}>
      {props.children}
    </VideoContext.Provider>
  )
}
